import { useEffect, useRef, useCallback } from 'react';

export const usePerformanceMonitor = (componentName: string) => {
    const renderStartTime = useRef<number>(0);
    const renderCount = useRef<number>(0);

    useEffect(() => {
        renderStartTime.current = performance.now();
        renderCount.current += 1;
    });

    useEffect(() => {
        const renderTime = performance.now() - renderStartTime.current;

        if (process.env.NODE_ENV === 'development') {
            console.log(`[Performance] ${componentName} render #${renderCount.current}: ${renderTime.toFixed(2)}ms`);

            // 警告慢渲染
            if (renderTime > 16) { // 超过一帧的时间
                console.warn(`[Performance Warning] ${componentName} slow render: ${renderTime.toFixed(2)}ms`);
            }
        }
    });

    const measureFunction = useCallback(<T extends (...args: any[]) => any>(
        fn: T,
        functionName: string
    ): T => {
        return ((...args: Parameters<T>) => {
            const start = performance.now();
            const result = fn(...args);
            const end = performance.now();

            if (process.env.NODE_ENV === 'development') {
                console.log(`[Performance] ${componentName}.${functionName}: ${(end - start).toFixed(2)}ms`);
            }

            return result;
        }) as T;
    }, [componentName]);

    return { measureFunction };
};